var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pageName"}},[_c('p',{staticClass:"pageName"},[_c('span',[_vm._v("Step"+_vm._s(_vm.step))]),_vm._v(_vm._s(_vm.pageTitle[_vm.step-1]))])])}
var staticRenderFns = []

export { render, staticRenderFns }